import { THistory } from "../types"
import { get } from "./axiosClient"

type GetHistoryRequest = {
    token: string | undefined
}

type GetHistoryResponse = {
    histories?: THistory[],
    errorMessage?: string
}

export const getHistory = async ({ token }: GetHistoryRequest): Promise<GetHistoryResponse> => {
    return await get({
        params: {},
        path: 'websystem/history',
        token: token
    }).then((res) => {
        if (res.status === 200) {
            return { histories: res.data }
        } else {
            return { errorMessage: res.data }
        }
    })
}